function CreditCard({ dimensions, col = '#000' }) {
    const baseXml = `
      <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="5" width="20" height="14" rx="2" stroke=${`"${col}"`} stroke-width="2"/>
        <line x1="2" y1="10" x2="22" y2="10" stroke=${`"${col}"`} stroke-width="2"/>
        <rect x="5" y="14" width="3" height="2" fill=${`"${col}"`}/>
      </svg>
    `;

    return baseXml;
}

export default CreditCard;
